import React from "react";
import { RootElement } from "./src/components/root-element";
import "@fontsource/work-sans/100.css"; // Weight 100 with normal styles included.
import "@fontsource/work-sans/300.css"; // Weight 300 with normal styles included.
import "@fontsource/work-sans/400.css"; // Weight 400 with normal styles included.
import "@fontsource/work-sans/500.css"; // Weight 500 with normal styles included.

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};
